<template>
  <q-card flat :style="!$q.screen.lt.md?'width: 700px; max-width: 80vw;':''">
    <q-card-section class="row items-center q-pb-none">
      <div>
        <div class="text-bold">{{ selectedCustomer.Cs_Name }}
          <q-badge v-if="selectedCustomer.State_Name!=='' && selectedCustomer.State_Name!=null" align="top"
                   :label="selectedCustomer.State_Name" color="brown-5"/>
          <q-badge v-if="selectedCustomer.City_Name!=='' && selectedCustomer.City_Name!=null" align="top"
                   :label="selectedCustomer.City_Name" color="brown-5" class="q-ml-xs"/>
        </div>
        <div class="row q-ml-xs">
          <q-badge color="deep-orange-14"><i>شناسه(</i><b>{{ selectedCustomer.Cs_Code }}</b><i>)</i>
          </q-badge>
          <q-badge v-if="selectedCustomer.RemCredit > 0" color='red-14' class="q-ml-xs"><i>بدهکاری(</i><b
              dir="ltr">{{ Math.abs(selectedCustomer.RemCredit) | toCurrency }}</b><i>) ریال</i>
          </q-badge>
        </div>
      </div>
      <q-space/>
      <q-btn icon="print" flat round dense @click="loadReport"/>
      <q-btn icon="close" flat round dense v-close-popup/>
    </q-card-section>
    <q-card-section class="row items-center justify-center q-pa-none q-mt-md">
    </q-card-section>
    <q-card-section>
      <q-select
          :dense="$q.screen.lt.md"
          class="q-mb-xs"
          v-model="logType"
          filled
          :options="visitLogTypeList"
          label="فیلتر اطلاعات"
      />
      <q-expansion-item
          class="shadow-1 overflow-hidden"
          style="border-radius: 10px"
          icon="shopping_cart"
          label="بازدیدها و سفارشات"
          header-class="bg-indigo-10 text-white"
          expand-icon-class="text-white">
        <q-input class="q-ma-xs" filled type="search" v-model="filter" label="جستجو">
          <template v-slot:prepend>
            <q-icon name="search"/>
          </template>
        </q-input>
        <q-timeline color="secondary" class="q-pa-md">
          <q-timeline-entry v-for="row in lodash.orderBy(timeLineEntriesOptions, ['VisitDateTime'], ['desc'])"
                            :key="row.ID"
                            color="indigo"
                            clas
                            :icon="row.VisiType==='بازدید در محل'?'visibility':'shopping_cart'">
            <template v-slot:subtitle>
              <span dir="ltr">{{ row.VisitDateTime | toJalaliDateTime }}</span>
            </template>
            <q-card flat>
              <q-card-section class="no-padding">
                {{ row.VisiType }} توسط
                <q-chip square :size="$q.screen.lt.md?'sm':'md'" :label="row.UserName" icon="support_agent"/>
                <q-chip square :size="$q.screen.lt.md?'sm':'md'" color="red" text-color="white"
                        v-if="row.IsSecret"
                        label="محرمانه" icon="visibility"/>
              </q-card-section>
              <q-card-section class="text-caption text-bold no-padding">
                {{ row.VisitComment }}
              </q-card-section>
              <q-card-section v-if="row.GroupsInfo && row.GroupsInfo!=='NULL'" class="no-padding">
                <q-chip size="sm" square v-for="(item, index) in JSON.parse(row.GroupsInfo)"
                        icon="tag"
                        :key="index" :label="item.Group_Name"/>
              </q-card-section>
            </q-card>
          </q-timeline-entry>
        </q-timeline>
      </q-expansion-item>

      <q-expansion-item
          class="shadow-1 overflow-hidden q-mt-xs"
          style="border-radius: 10px"
          v-if="$store.state.roles.some(v=>['admin','can_sea_call_report'].includes(v))"
          icon="local_phone"
          :label="`تعداد تماس ها (${calls.length}) به مدت (${convertSecondToTime(lodash.sumBy(calls, x => getDateTimeDiff(x.endtime, x.starttime)))})`"
          header-class="bg-indigo-10 text-white"
          expand-icon-class="text-white">
        <q-timeline color="secondary" class="q-pa-md">
          <q-timeline color="secondary" class="q-pa-md">
            <q-timeline-entry
                v-for="row in calls"
                :key="row.ID"
                :color="row.Calldirection==='Incoming'?'indigo':'green'"
                icon="local_phone">
              <template v-slot:subtitle>
                <span dir="ltr">{{ row.starttime | toJalaliDateTime }}</span>
              </template>
              <CallLogInfo :log="row"/>
            </q-timeline-entry>
          </q-timeline>
        </q-timeline>
      </q-expansion-item>

      <q-expansion-item
          class="shadow-1 overflow-hidden q-mt-xs"
          style="border-radius: 10px"
          icon="sms"
          :label="`پیامک های ارسال شده (${sms_logs.length})`"
          header-class="bg-indigo-10 text-white"
          v-if="$store.state.roles.some(v=>['admin','can_read_sms_log'].includes(v))"
          expand-icon-class="text-white">
        <q-timeline color="secondary" class="q-pa-md">
          <q-timeline color="secondary" class="q-pa-md">
            <q-timeline-entry
                v-for="row in sms_logs"
                :key="row.id"
                color="indigo"
                icon="sms">
              <template v-slot:subtitle>
                <span dir="ltr">{{ row.date_time }}</span>
              </template>
              {{ row.message }}
              <q-chip square icon="support_agent" :label="row.user_name"/>
            </q-timeline-entry>
          </q-timeline>
        </q-timeline>
      </q-expansion-item>

      <q-expansion-item
          class="shadow-1 overflow-hidden q-mt-xs"
          style="border-radius: 10px"
          icon="local_phone"
          :label="`تعداد تماس های بی پاسخ (${miss_called.length})`"
          header-class="bg-indigo-10 text-white"
          v-if="$store.state.roles.some(v=>['admin','can_read_miss_called'].includes(v))"
          expand-icon-class="text-white">
        <q-timeline color="secondary" class="q-pa-md">
          <q-timeline color="secondary" class="q-pa-md">
            <q-timeline-entry
                v-for="row in miss_called"
                :key="row.ID"
                color="red"
                icon="phone_disabled">
              <template v-slot:subtitle>
                <span dir="ltr">{{ row.CallStart| toJalaliDateTime }}</span>
              </template>
            </q-timeline-entry>
          </q-timeline>
        </q-timeline>
      </q-expansion-item>

    </q-card-section>
    <q-dialog
        v-model="showTimeLineEntryDialog">
      <c-u-visit-log @event-added="eventAdded" :selected-customer="this.selectedCustomer"/>
    </q-dialog>
  </q-card>
</template>

<script>
import CUVisitLog from "@/components/customers/CUVisitLog";
import {mapActions} from "vuex";
import CallLogInfo from "@/components/callCenter/CallLogInfo";

export default {
  name: "VisitLog",
  components: {CallLogInfo, CUVisitLog},
  props: ["logs", "selectedCustomer"],
  data() {
    return {
      showTimeLineEntryDialog: false,
      timeLineEntries: [],
      timeLineEntriesOptions: [],
      calls: [],
      au: undefined,
      visitLogTypeList: this.$store.state.visitLogTypeList.map(item => item.title),
      logType: '',
      filter: '',
      miss_called: [],
      sms_logs: []
    }
  },
  methods: {
    ...mapActions({
      GetCustomerVisitLog: 'Customers/get_customer_visit_log',
      GetCustomerPlayVoice: 'Customers/get_customer_phone_voice'
    }),
    async loadReport() {
      await this.openURL(`https://report.norl.ir/Reports/report/ECAPPV2/گزارشات مرتبط با مشتریان/گزارشات ثبت شده مشتری?rs:Format=PDF&Code=${this.selectedCustomer.Cs_Code}&rc:Parameters=False&rc:Zoom=Page Width`)
    },
    showTimelineEntryDialog() {
      this.showTimeLineEntryDialog = true;
    },
    playRecordedVoice(row) {
      if (this.au !== undefined) {
        this.au.pause()
      }
      this.GetCustomerPlayVoice(row.Filename).then((res) => {
        let bl = new Blob([res.data], {type: 'audio/mp3;'});
        let blobUrl = URL.createObjectURL(bl);
        this.au = new Audio(blobUrl)
        this.au.play()
      }).catch((err) => {
        console.log(err)
      })
    },
    download(row) {
      this.GetCustomerPlayVoice(row.Filename).then((res) => {
        let bl = new Blob([res.data], {type: 'audio/mp3;'});
        const FileSaver = require('file-saver');
        FileSaver.saveAs(bl, row.FileName);
      })
    },
    eventAdded(e) {
      this.timeLineEntries.push(e[0])
      this.showTimeLineEntryDialog = false;
    }
  },
  watch: {
    logType: function (val) {
      if (val === 'همه موارد') {
        this.timeLineEntriesOptions = this.timeLineEntries
      } else {
        this.timeLineEntriesOptions = this.timeLineEntries.filter(item => item.LogType === val)
      }
    },
    filter: function (val) {
      if (val === '') {
        this.timeLineEntriesOptions = this.timeLineEntries
      } else {
        if (this.logType === '') {
          this.timeLineEntriesOptions = this.timeLineEntries.filter(item => item.VisitComment.includes(val))
        } else {
          this.timeLineEntriesOptions = this.timeLineEntries.filter(item => item.LogType === this.logType && item.VisitComment.includes(val))
        }
      }
    }
  },
  created() {
    this.GetCustomerVisitLog({Cs_ID: this.selectedCustomer.Cs_ID}).then((res) => {
      this.calls = this.lodash.orderBy(JSON.parse(res.data.calls), ['Starttime'], ['desc'])
      if (this.$store.state.roles.some(v => ['admin', 'can_see_secret_comment'].includes(v))) {
        this.timeLineEntries = JSON.parse(res.data.visit_log).filter(item => !item.IsSecret);
      } else {
        this.timeLineEntries = JSON.parse(res.data.visit_log);
      }
      this.timeLineEntriesOptions = this.timeLineEntries;
      this.miss_called = eval(res.data.miss_called)
      this.sms_logs = JSON.parse(res.data.sms_log)
    });
  }
}
</script>

<style scoped>

</style>
